import { AccountClosedByStatuses } from './AccountClosedByStatuses';

export const AccountClosedByStatusDescriptions:Map<AccountClosedByStatuses, string> = new Map([
  [AccountClosedByStatuses.CLOSED_DATE, 'Closed Date'],
  [AccountClosedByStatuses.STATUS_CODE, 'Status Code'],
  [AccountClosedByStatuses.CLOSED_DATE_AND_STATUS_CODE, 'Closed Date AND Status Code'],
  [AccountClosedByStatuses.CLOSED_DATE_OR_STATUS_CODE, 'Closed Date OR Status Code'],
]);

export default AccountClosedByStatusDescriptions;
